const map = {
    '全部': '',
    '新增': 'create',
    '更新翻譯': 'update',
    '更新單號': 'update-ticket',
    '刪除': 'delete',
    '上版': 'approve',
    '審核': 'review',
}

export const convertUpdateTypeToChangeType = (updateType) => map[updateType] ?? ''


export const convertChangeTypeToUpdateType = (changeType) => 
    Object.entries(map).find(entry => 
         entry[1] === changeType
    )?.[0] ?? '全部'
